import {
  SortField,
  Sort,
} from "~/pages/Brand/Suppliers/List/SupplierMonitoringWrapper.tsx"

export function isSort(value: string | null): value is Sort {
  if (!value) {
    return false
  }
  const sortFields: SortField[] = ["name", "requests"]
  const [field, order] = value.split("-")
  return (
    sortFields.includes(field as SortField) && ["asc", "desc"].includes(order)
  )
}
